import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { ISkeletonType } from './Types';

function LinesSkeleton({lines}: ISkeletonType) {
  return (<>
    <Box display='flex'
      gap='25px'
      flexDirection='column'
      justifyContent='flex-start'
      margin={2}
    >
      {
        [...Array(lines)].map((_,key) => {
          return (
            <Skeleton
              animation='wave'
              key={key}
              sx={{maxWidth: '700px', minWidth: '450px' }}
            >
            </Skeleton>
          );
        })
      }
    </Box>
  </>);
}

export default LinesSkeleton;